import { render } from "./TeamProfile.vue?vue&type=template&id=96683774"
import script from "./TeamProfile.vue?vue&type=script&lang=js"
export * from "./TeamProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__